import React from "react";
import { Form, Input, InputNumber, Select } from "antd";

const { TextArea } = Input;

function Production({ dataVariety }) {
  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Production
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="cropAcreage"
          label={"Total Area Under Rice Production (Acres)"}
        >
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item name="varietyIds" label={"Varieties"}>
          <Select
            mode="multiple"
            allowClear
            placeholder="Select varieties"
            style={{
              width: "100%",
            }}
            options={
              dataVariety?.length > 0 &&
              dataVariety?.map((item) => ({
                value: item?.cvId,
                label: item?.cvVariety,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </div>
      <Form.Item
        name="ongoingInterventions"
        label={"Ongoing Rice Interventions to Increase Rice Production"}
        extra={
          "Capture the interventions currently running and what each is meant  to change"
        }
      >
        <TextArea rows={3} className="text_area" />
      </Form.Item>
    </>
  );
}

export default Production;
